export const GET_NUTRITION_LOGS_SUCCEED = 'Logs/GET_NUTRITION_LOGS_SUCCEED';
export const GET_NUTRITION_LOGS_ERROR = 'Logs/GET_NUTRITION_LOGS_ERROR';
export const GET_ALL_NUTRITION_LOGS_SUCCEED = 'Logs/GET_ALL_NUTRITION_LOGS_ERROR';
export const GET_ALL_NUTRITION_LOGS_ERROR = 'Logs/GET_ALL_NUTRITION_LOGS_ERROR';
export const GET_NUTRITION_SUMMARY_SUCCEED = 'NutritionSummary/GET_NUTRITION_SUMMARY_SUCCEED';
export const GET_NUTRITION_SUMMARY_ERROR = 'NutritionSummary/GET_NUTRITION_SUMMARY_ERROR';
export const LOADING_STATE = "NutritionSummary/LOADING_STATE";
export const LOADING_NUTRITION_LOG_STATE = 'Logs/LOADING_NUTRITION_LOG_STATE';
export const LOADING_ALL_NUTRITION_LOG_STATE = 'Logs/LOADING_ALL_NUTRITION_LOG_STATE';
export const TYPE = 'type';
export const MEAL = 'meal';
export const SNACK = 'snack';
export const DRINK = 'drink';
export const WATER = 'water';
export const DATE = 'date';
export const PAGE_SIZE = 12;
